import {Component, h, Fragment} from "preact";
import {Modal} from "../../_common/components/modal";
import {t} from "../../_i18n";
import {connect} from "react-redux";
import {E, FR, R} from "../../_common/layout";
import {RadioCheckbox, InputField} from "../../_common/forms/components/components";
import {OFFERS_LIMIT_PAGES} from "../../constants";
import {fetchCandidatesCount} from "../../_rx/jobs/actions";

const initialState = {
    academicPrograms: {},
    states: {},
    academicProgramMax: '',
    academicProgramMin: '',
    questionsPercentMax: '',
    questionsPercentMin: '',
}

const MODALITY_NORMAL = "normal"

type PropsReact = {
    id: string,
    fixtures: any
    status: string,
    idOffer: number,
    tab: string,
    order: string,
    offerReducer: any,
    onClick: any,
    companyCandidatesCount: any,
    companyOffersApplicationFilter: any,
    fetchCandidatesCount: typeof fetchCandidatesCount
}

type StateReact = {
    academicPrograms: any,
    states: any,
    academicProgramMax: any,
    academicProgramMin: any,
    questionsPercentMax: any,
    questionsPercentMin: any,
}


class View extends Component<PropsReact, StateReact> {
    constructor(props: any) {
        super(props);
        this.state = initialState;
    }

    renderCandidatesNum = (offersNum: number) => {
        let text: string = '';
        if (offersNum === 1) {
            text = offersNum + " " + t("candidato")
        } else if (offersNum > 1 || offersNum === 0) {
            text = offersNum + " " + t("candidatos")
        }
        return text;
    }

    initializeObjectToSend = (ob: any = false) => {
        const statesArray: any = [];
        const academicProgramsArray: any = [];
        let states = this.state.states;
        let academicPrograms = this.state.academicPrograms;
        let academicProgramMin = this.state.academicProgramMin;
        let academicProgramMax = this.state.academicProgramMax;
        let questionsPercentMax = this.state.questionsPercentMax;
        let questionsPercentMin = this.state.questionsPercentMin;

        if (ob) {
            states = ob.states;
            academicPrograms = ob.academicPrograms;
            academicProgramMin = ob.academicProgramMin;
            academicProgramMax = ob.academicProgramMax;
            questionsPercentMax = ob.questionsPercentMax;
            questionsPercentMin = ob.questionsPercentMin;
        }

        Object.keys(states).filter(statesItem => (states[statesItem])
            && Object.keys(this.props.fixtures.states).find((key: any) => (this.props.fixtures.states[key] === statesItem) && statesArray.push(key)));

        Object.keys(academicPrograms).filter(academicProgramsItem => (academicPrograms[academicProgramsItem])
            && Object.keys(this.props.fixtures.academic_programs).find((key: any) => (this.props.fixtures.academic_programs[key] === academicProgramsItem) && academicProgramsArray.push(key)));

        let objectToSend = {}

        if (statesArray.length > 0)
            objectToSend = {...objectToSend, states: statesArray.join(",")}

        if (academicProgramsArray.length > 0)
            objectToSend = {...objectToSend, academicPrograms: academicProgramsArray.join(",")}

        if (academicProgramMin)
            objectToSend = {...objectToSend, minAcademicProgramPercent: parseInt(this.state.academicProgramMin)}
        if (academicProgramMax)
            objectToSend = {...objectToSend, maxAcademicProgramPercent: parseInt(this.state.academicProgramMax)}
        if (questionsPercentMax)
            objectToSend = {...objectToSend, maxQuestionsPercent: parseInt(this.state.questionsPercentMax)}
        if (questionsPercentMin)
            objectToSend = {...objectToSend, minQuestionsPercent: parseInt(this.state.questionsPercentMin)}

        return objectToSend
    }

    submitFilter = () => {
        let objectToSend = this.initializeObjectToSend();
        this.props.onClick(objectToSend);
        history.back();
    }

    async updateNumberCandidates ({states, academicPrograms, academicProgramMin, academicProgramMax, questionsPercentMax, questionsPercentMin}: any) {
        let objectToSend = this.initializeObjectToSend({states, academicPrograms, academicProgramMin, academicProgramMax, questionsPercentMax, questionsPercentMin});
        await this.props.fetchCandidatesCount({id: this.props.idOffer, status: this.props.tab, ...objectToSend});
    }

    render = ({id, fixtures, offerReducer: {offerSelected}, companyOffersApplicationFilter, companyCandidatesCount}: PropsReact) => <Modal id={id} title={t('Filtrar candidatos')} className="md-no-fullscreen" withHeaderTitle>
        <div className="in-modal-scroll sm-p-x2-left sm-p-x2-right p-right p-left">
            {companyOffersApplicationFilter.showAcademicProgramScopes && <Fragment>
                <FR>
                    <E className='t-left sm-p-top'>
                        <h3>{t('Titulación')}</h3>
                    </E>
                </FR>
                <FR className="row-1-el sm-no-margin-bottom">
                    {(companyOffersApplicationFilter.academicProgramScopeList).map((key: any) => {
                            const label: any = key['name'];
                            return <E className='t-left'>
                                <RadioCheckbox name={label}
                                               type="checkbox"
                                               label={t(label)}
                                               defaultValue={(this.state.academicPrograms[label]) ? this.state.academicPrograms[label] : false}
                                               onChange={(val: boolean) => {
                                                   this.setState({
                                                       academicPrograms: {
                                                           ...this.state.academicPrograms,
                                                           [label]: val
                                                       }
                                                   }, () => {
                                                       this.updateNumberCandidates({states: this.state.states, academicPrograms: this.state.academicPrograms, academicProgramMin: this.state.academicProgramMin, academicProgramMax: this.state.academicProgramMax, questionsPercentMax: this.state.questionsPercentMax, questionsPercentMin: this.state.questionsPercentMin});
                                                   });
                                               }
                                               }/>
                            </E>
                        }
                    )}
                </FR>
            </Fragment>}

            {(companyOffersApplicationFilter.showFinishedPercent && offerSelected.modality === MODALITY_NORMAL && offerSelected.acceptUnfinished) && <Fragment>
                <hr className="separator-xxs"/>
                <h3>{t('Porcentaje de titulación')}</h3>
                <FR className='flexrow'>
                    <E className='sm-col-20 col-50'>
                        <InputField name="Mínimo" label="Mínimo" type='number'
                                    min={0} max={100}
                                    defaultValue={this.state.academicProgramMin}
                                    onBlur={(val: any) => {
                                        this.setState({
                                            academicProgramMin: val.target.value
                                        }, () => {
                                            this.updateNumberCandidates({states: this.state.states, academicPrograms: this.state.academicPrograms, academicProgramMin: this.state.academicProgramMin, academicProgramMax: this.state.academicProgramMax, questionsPercentMax: this.state.questionsPercentMax, questionsPercentMin: this.state.questionsPercentMin});
                                        });
                                    }
                        }/>
                    </E>
                    <E className='sm-col-20 col-50'>
                        <InputField name="Máximo" label="Máximo" type='number'
                                    min={0} max={100}
                                    defaultValue={this.state.academicProgramMax}
                                    onBlur={(val: any) => {
                                        this.setState({
                                            academicProgramMax: val.target.value
                                        }, () => {
                                            this.updateNumberCandidates({states: this.state.states, academicPrograms: this.state.academicPrograms, academicProgramMin: this.state.academicProgramMin, academicProgramMax: this.state.academicProgramMax, questionsPercentMax: this.state.questionsPercentMax, questionsPercentMin: this.state.questionsPercentMin});
                                        });
                                    }

                        }/>
                    </E>
                    <E className='col-60'/>
                </FR>
            </Fragment>}

            {companyOffersApplicationFilter.showKillerGrade && <Fragment>
                <hr className="separator-xxs"/>
                <h3>{t('Porcentaje de nota de las preguntas')}</h3>
                <FR>
                    <E className='sm-col-20 col-50'>
                        <InputField name="Mínimo" label="Mínimo" type='number'
                                    min={0} max={100}
                                    defaultValue={this.state.questionsPercentMin}
                                    onBlur={(val: any) => {
                                        this.setState({
                                            questionsPercentMin: val.target.value
                                        }, () => {
                                            this.updateNumberCandidates({
                                                states: this.state.states,
                                                academicPrograms: this.state.academicPrograms,
                                                academicProgramMin: this.state.academicProgramMin,
                                                academicProgramMax: this.state.academicProgramMax,
                                                questionsPercentMax: this.state.questionsPercentMax,
                                                questionsPercentMin: this.state.questionsPercentMin
                                            });
                                        });
                                    }
                                    }/>
                    </E>
                    <E className='sm-col-20 col-50'>
                        <InputField name="Máximo" label="Máximo" type='number'
                                    min={0} max={100}
                                    defaultValue={this.state.questionsPercentMax}
                                    onBlur={(val: any) => {
                                        this.setState({
                                            questionsPercentMax: val.target.value
                                        }, () => {
                                            this.updateNumberCandidates({
                                                states: this.state.states,
                                                academicPrograms: this.state.academicPrograms,
                                                academicProgramMin: this.state.academicProgramMin,
                                                academicProgramMax: this.state.academicProgramMax,
                                                questionsPercentMax: this.state.questionsPercentMax,
                                                questionsPercentMin: this.state.questionsPercentMin
                                            });
                                        });
                                    }
                                    }/>
                    </E>
                    <E className='col-60'/>
                </FR>
            </Fragment>}

            {companyOffersApplicationFilter.showStates && <Fragment>
                <hr className="separator-xxs"/>
                <h3>{t('Provincias')}</h3>
                <FR className="sm-row-3-el row-2-el">
                    {(companyOffersApplicationFilter.stateList).map((key: any) => {
                            const label: any = key['name'];
                            return <E>
                                <RadioCheckbox name={label}
                                               type="checkbox"
                                               label={t(label)}
                                               defaultValue={(this.state.states[label]) ? this.state.states[label] : false}
                                               onChange={(val: boolean) => {
                                                   this.setState({
                                                       states: {
                                                           ...this.state.states,
                                                           [label]: val
                                                       }
                                                   }, () => {
                                                       this.updateNumberCandidates({states: this.state.states, academicPrograms: this.state.academicPrograms, academicProgramMin: this.state.academicProgramMin, academicProgramMax: this.state.academicProgramMax, questionsPercentMax: this.state.questionsPercentMax, questionsPercentMin: this.state.questionsPercentMin});
                                                   });
                                               }
                                               }/>
                            </E>
                        }
                    )}
                </FR>
            </Fragment>}
        </div>
        <hr className="separator-xxs"/>
        <FR className="sm-row-2-el row-1-el flex-center-y modal-footer-padding">
            <E className="t-center sm-no-t-center">
                <button className="btn btn-primary" type='submit' onClick={() => this.submitFilter()}>
                    {companyCandidatesCount && t('Mostrar ' + this.renderCandidatesNum(companyCandidatesCount.count))}
                </button>
            </E>
            <E className="t-center sm-t-right">
                <a className="txt-color-primary font-14 t-underline" onClick={() => {this.setState(initialState); this.props.onClick({}); this.updateNumberCandidates(initialState);}}>{t('QUITAR FILTROS')}</a>
            </E>
        </FR>
    </Modal>


}

const ConnectedView: any = connect(
    ({fixtures, offerReducer, companyOffersApplicationFilter, companyCandidatesCount}: any)=>({fixtures, offerReducer, companyOffersApplicationFilter, companyCandidatesCount}), {fetchCandidatesCount})(View as any);


export default ({id, companyOffersApplicationFilter, onClick, idOffer, tab}: any) =>
    <ConnectedView id={id} companyOffersApplicationFilter={companyOffersApplicationFilter} onClick={onClick} idOffer={idOffer} tab={tab}/>
;
